<template>
  <v-card>
    <v-card-title>
      <span class="headline">
        {{ isJoin ? 'Join Scoopr' : 'Log In' }}
      </span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                label="Password"
                required
              ></v-text-field>
            </v-form>
          </v-col>
          <v-col cols="12">
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4 w-100"
              @click="isJoin ? join() : login()"
              large
            >
              {{ isJoin ? 'Create Account' : 'Login' }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            <v-btn
              class="w-100"
              @click="signOn"
            >
              Sign on with Google
            </v-btn>
          </v-col>
        </v-row> -->
      </v-container>
    </v-card-text>
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        :color="!isJoin ? 'primary' : 'grey'"
        @click="isJoin = false"
      >
        Login
      </v-btn>
      <v-btn
        text
        :color="isJoin ? 'primary' : 'grey'"
        @click="isJoin = true"
      >
        Create Account
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import Vue from 'vue'
import { auth } from '@/auth/index.js'

export default Vue.extend({
  name: 'SignOn',

  components: {
  },

  props: {
    initJoin: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    isJoin: false,
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    password: '',
    passwordRules: [
      v => /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(v) || 'Password must be atleast 8 characters, have uppercase letters, and numbers.'
    ]
  }),

  created () {
    // this.isJoin = this.initJoin ? this.isJoin : !this.isJoin // default true
  },

  methods: {
    login () {
      this.$refs.form.validate()
      if (this.valid) {
        auth.emailLogIn(
          this.email,
          this.password
        ).then(() => this.redirect())
      }
    },
    signOn () {
      auth.socialLogin()
        .then(() => this.redirect())
    },
    join () {
      this.$refs.form.validate()
      if (this.valid) {
        auth.emailSignup(
          this.email,
          this.password
        ).then(() => this.redirect())
      }
    },
    redirect () {
      this.$router.push('/dashboard')
    }
  }
})
</script>
